/* 인스타그램·틱톡 공유 (2026-10-20 의장 「x 빼고 인스타그램 넣어. 이메일도 빼자. 틱톡을 넣자」)

   ⚠ 인스타그램과 틱톡은 **주소로 공유를 받는 창구가 없다.**
      페이스북(`sharer.php?u=`)·핀터레스트(`pin/create/button/?url=`)처럼 보낼 데가 없다.

   보낼 수 있는 길은 **휴대폰의 운영체제 공유 시트 하나뿐**이다 — 그 시트 안에 두 앱이 뜬다.

   ✅ **2026-10-20 늦게 「Copy link」 단추가 따로 생겼다** (의장 「쉐어에서 링크 복사할 수 있게 만들어놔」).
      ⚠ 아래 ⛔ 와 **부딪치지 않는다.** 물린 것은 「인스타그램 아이콘이 복사만 하던 것」이고,
         새로 넣은 것은 **이름이 「Copy link」인 제 단추**다. 하는 일과 이름이 같으면 괜찮다.
      ⚠ 그래서 **이 단추를 아래 ⛔ 를 근거로 지우지 않는다.**

   ⛔ 처음에는 데스크톱에서 **링크 복사**로 때웠는데 의장이 물리셨다:
      **「링크 카피하는건 의미가 없어」**. 맞다 — 인스타그램 아이콘을 눌렀는데
      인스타그램으로 가지 않으면 그건 공유가 아니다.
   ⇒ 그래서 **되는 자리에만 단추를 둔다.** 공유 시트가 있는 기기에서만 보이고,
      그 밖에서는 아예 나오지 않는다(페이스북·핀터레스트만 남는다).

   ⚠ 데스크톱 크롬에도 `navigator.share` 가 있다(실측 2026-10-20, 1440). **그래도 쓰면 안 된다** —
      시트에 뜨는 것은 브라우저가 아니라 **그 컴퓨터에 깔린 앱**이고, 맥에는 두 앱이 없다.
      2026-10-20 의장이 직접 띄워 확인하셨다: **없었다.** 그래서 손가락 기기에서만 내보낸다. */
(function () {
  'use strict';

  function 보낼수있나() {
    /* ✅ 2026-10-20 **의장이 직접 눌러 확인했다 — 맥 공유 시트에 인스타그램·틱톡이 없었다.**
       (「없네. 데스크톱은 다시 숨겨」) 그래서 손가락 기기에서만 단추를 내보낸다.
       시트에 뜨는 것은 브라우저가 아니라 **그 컴퓨터에 깔린 앱**이고,
       두 서비스는 맥용 앱이 없다. 데스크톱 크롬에 `navigator.share` 가 있는 것과는 별개다 —
       **있다고 해서 보낼 수 있는 것이 아니다.**
       ⚠ 이 줄을 `return !!navigator.share;` 로 풀면 데스크톱에도 다시 나온다. 풀지 않는다. */
    if (!navigator.share) { return false; }
    return !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
  }

  /* 보낼 수 있는 기기에서만 단추를 드러낸다 (CSS 가 이 표시를 보고 숨기거나 보인다) */
  function 표시하기() {
    document.documentElement.classList.toggle('ue-canshare', 보낼수있나());
  }

  표시하기();
  window.addEventListener('resize', 표시하기);

  document.addEventListener('click', function (e) {
    var 단추 = e.target.closest ? e.target.closest('[data-ue-share]') : null;
    if (!단추) { return; }
    e.preventDefault();
    if (!보낼수있나()) { return; }

    navigator.share({
      title: 단추.getAttribute('data-ue-share-title') || document.title,
      url: 단추.getAttribute('data-ue-share-url') || window.location.href
    }).catch(function () { /* 손님이 닫은 것 — 조용히 둔다 */ });
  }, false);

  /* ── 링크 복사 ────────────────────────────────────────────────
     2026-10-20 의장 「쉐어에서 링크 복사할 수 있게 만들어놔」

     ⚠ 앞서 물린 「링크 카피」와 **다른 것**이다. 그때 문제는
        **인스타그램 아이콘을 눌렀는데 복사만 되는 것**이었다 — 아이콘과 하는 일이 달랐다.
        여기는 **이름이 「Copy link」인 제 단추**다. 하는 일과 이름이 같다.

     ⚠ 복사하는 길이 **두 가지**다. 하나만 두면 조용히 실패한다.
        ① `navigator.clipboard.writeText` — 요즘 브라우저. **https 와 사람의 누름**이 있어야 한다
        ② 숨긴 칸 + `document.execCommand('copy')` — ①이 없거나 거절할 때.
           ⛔ 칸을 `display:none` 으로 두면 **고를 수 없어 복사가 안 된다** — 화면 밖에 둔다
        ⚠ iOS 는 `readonly` 칸을 못 고른다 — `contentEditable` 로 한 번 더 뚫는다
     ⚠ 둘 다 실패하면 **쪽지로 「복사됐다」고 말하지 않는다.** 주소를 보여 주고 직접 집게 한다. */

  var 쪽지 = null, 쪽지시계 = null;

  function 쪽지보이기(글, 단추, 참인가) {
    if (!쪽지) {
      쪽지 = document.createElement('div');
      쪽지.className = 'ue-share-toast';
      쪽지.setAttribute('role', 'status');
      쪽지.setAttribute('aria-live', 'polite');
      document.body.appendChild(쪽지);
    }
    쪽지.textContent = 글;
    쪽지.classList.toggle('ue-share-toast--fail', !참인가);

    /* 단추 위에 띄우고 **화면 안으로 밀어 넣는다** — 목록 끝의 단추는 오른쪽으로 넘친다 */
    쪽지.classList.add('is-on');
    var r = 단추.getBoundingClientRect();
    var 내폭 = 쪽지.offsetWidth, 내높이 = 쪽지.offsetHeight;
    var x = r.left + r.width / 2 - 내폭 / 2;
    var y = r.top - 내높이 - 10;
    if (x < 8) { x = 8; }
    if (x + 내폭 > window.innerWidth - 8) { x = window.innerWidth - 8 - 내폭; }
    if (y < 8) { y = r.bottom + 10; }          /* 위가 없으면 아래로 */
    쪽지.style.left = Math.round(x) + 'px';
    쪽지.style.top = Math.round(y) + 'px';

    if (쪽지시계) { clearTimeout(쪽지시계); }
    쪽지시계 = setTimeout(function () { 쪽지.classList.remove('is-on'); }, 참인가 ? 1800 : 5000);
  }

  function 옛방식으로복사(글) {
    var 칸 = document.createElement('textarea');
    칸.value = 글;
    칸.setAttribute('readonly', '');
    칸.contentEditable = 'true';
    /* 화면 밖에 둔다. `display:none` 이면 고를 수 없어 복사가 안 된다 */
    칸.style.cssText = 'position:fixed;top:0;left:-9999px;opacity:0;';
    document.body.appendChild(칸);
    var 됐나 = false;
    try {
      칸.focus();
      칸.setSelectionRange(0, 글.length);
      칸.select();
      됐나 = document.execCommand('copy');
    } catch (e) { 됐나 = false; }
    document.body.removeChild(칸);
    return 됐나;
  }

  function 복사하기(글, 단추) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(글).then(function () {
        쪽지보이기('Link copied', 단추, true);
      }).catch(function () {
        /* ⚠ `옛방식으로복사` 를 **두 번 부르지 않는다** — 두 번 복사되고,
              쪽지 글과 성공 여부가 서로 다른 호출의 결과가 된다(한 번 그렇게 적었다). */
        var 됐나 = 옛방식으로복사(글);
        쪽지보이기(됐나 ? 'Link copied' : 글, 단추, 됐나);
      });
      return;
    }
    var 됐나 = 옛방식으로복사(글);
    쪽지보이기(됐나 ? 'Link copied' : 글, 단추, 됐나);
  }

  document.addEventListener('click', function (e) {
    var 단추 = e.target.closest ? e.target.closest('[data-ue-copy]') : null;
    if (!단추) { return; }
    e.preventDefault();
    복사하기(단추.getAttribute('data-ue-copy-url') || window.location.href, 단추);
  }, false);

  /* ── 휴대폰 Share 가 **우리 팝오버**를 열게 한다 ──────────────────
     2026-10-20 의장 ㉯ 「휴대폰도 우리 팝오버를 열게 바꾼다」

     ⛔ **그 전까지 휴대폰에서는 우리 단추 셋이 손님 눈에 닿지 않았다.**
        테마 `ShareToggleButton` 이 이렇게 돼 있다(`assets/theme.js` 실측):
          if (폰판 && navigator.share) { navigator.share({...}) }   ← 운영체제 시트
          else                        { super._onButtonClick() }   ← 우리 팝오버
        요즘 휴대폰은 둘 다 참이므로 **언제나 위쪽**으로 갔다 — 인스타그램·틱톡·Copy link 가
        있는 팝오버는 **열리지 않았다**(실측: 클릭은 받는데 `aria-expanded` 가 false 그대로).

     ⇒ 테마가 시트로 새는 **그 경우에만** 누름을 가로채 우리가 판을 연다.

     ⚠ **프로토타입을 고쳐서는 안 된다.** 테마가 생성자에서
        `this.addEventListener('click', this._onButtonClick.bind(this))` 로 **묶어 두기** 때문에,
        요소가 만들어진 뒤에 프로토타입을 바꿔도 **옛 함수가 그대로 불린다.**
        (`customElements.define` 이 기존 요소를 그 자리에서 승격시키므로
         `whenDefined` 로 기다려도 이미 늦다.) 그래서 **누름 자체를 가로챈다** — 순서와 무관하다.

     ⚠ **테마 파일은 건드리지 않았다** — Focal 을 업데이트해도 살아남는다.
     ⚠ 가로채는 조건을 **테마의 조건과 똑같이** 둔다(폰판 + 공유 함수 있음).
        그 밖에서는 손대지 않아 종전 동작이 그대로다.
     ⚠ 열 판이 없으면 가로채지 않는다 — 아무 일도 못 하면서 테마만 막는 것이 가장 나쁘다. */

  function 폰판인가() {
    var 폭 = window.themeVariables && window.themeVariables.breakpoints
             && window.themeVariables.breakpoints.phone;
    if (!폭) { return false; }   /* 테마 값이 없으면 가로채지 않는다 — 짐작으로 막지 않는다 */
    return !!(window.matchMedia && window.matchMedia(폭).matches);
  }

  document.addEventListener('click', function (e) {
    var 단추 = e.target.closest ? e.target.closest('button[is="share-toggle-button"]') : null;
    if (!단추) { return; }
    if (!(폰판인가() && navigator.share)) { return; }   /* 테마가 시트로 새는 경우만 */
    var 이름 = 단추.getAttribute('aria-controls');
    if (!이름) { return; }
    var 판 = document.getElementById(이름);
    if (!판) { return; }

    e.preventDefault();
    e.stopImmediatePropagation();                       /* 테마의 제 손잡이가 못 돌게 한다 */
    단추.isExpanded = !단추.isExpanded;                  /* 테마의 setter — aria-expanded 가 판을 연다 */
  }, true);                                             /* ⚠ 받는 단계(capture)여야 한다 */
})();
